module.exports = __webpack_public_path__ + "img/150-bolivia.cc8d0efa.svg";